const onUnhandledRequestEnabled =
  process.env.NEXT_PUBLIC_API_MOCKING_WARN_ON_UNHANDLED_REQUESTS === 'enabled'
    ? 'warn'
    : 'bypass'

function onUnhandledRequestServer(
  request: { url: string | string[] },
  print: { warning: () => void },
) {
  if (onUnhandledRequestEnabled === 'bypass') {
    return
  }

  // Otherwise, print a warning for any unhandled request.
  print.warning()
}

export function onUnhandledRequestClient(
  request: { url: string | string[] },
  print: { warning: () => void },
): void {
  if (
    onUnhandledRequestEnabled === 'bypass' ||
    request.url.includes('/fonts.googleapis.com/') ||
    request.url.includes('/fonts.gstatic.com/') ||
    request.url.includes('/_next') ||
    request.url.includes('favicon') ||
    request.url.includes('recaptcha') ||
    request.url.includes('/images/') ||
    request.url === '/index.json'
  ) {
    return
  }

  // Otherwise, print a warning for any unhandled request.
  print.warning()
}

async function initMocks(): Promise<void> {
  if (typeof window === 'undefined') {
    const { server } = await import('./server')
    server.listen({ onUnhandledRequest: onUnhandledRequestServer })
  } else {
    const { worker } = await import('./browser')
    await worker.start({ onUnhandledRequest: onUnhandledRequestClient })
  }
}

export { initMocks }
